import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as Sentry from "@sentry/react";

const isProduction = process.env.NODE_ENV === 'production';
const release = process.env.REACT_APP_RELEASE || process.env.REACT_APP_GIT_SHA || undefined;

const scrubSentryEvent = (event) => {
  if (event?.request?.url) {
    event.request.url = String(event.request.url).split('?')[0];
  }
  if (event?.request?.headers) {
    delete event.request.headers.authorization;
    delete event.request.headers.Authorization;
    delete event.request.headers.cookie;
    delete event.request.headers.Cookie;
  }
  if (event?.user) {
    delete event.user.email;
    delete event.user.ip_address;
  }
  return event;
};

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: isProduction ? 0.1 : 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.NODE_ENV,
  release,
  beforeSend: scrubSentryEvent,
});

Sentry.setTag('property_id', process.env.REACT_APP_PROPERTYID);

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

